var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisabledShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3261 8.50519C16.5296 8.33082 16.6313 8.24364 16.6686 8.13989C16.7013 8.04883 16.7013 7.94922 16.6686 7.85816C16.6313 7.75441 16.5296 7.66722 16.3261 7.49285L9.26719 1.44233C8.917 1.14217 8.74191 0.992087 8.59367 0.98841C8.46483 0.985214 8.34177 1.04181 8.26035 1.14171C8.16667 1.25666 8.16667 1.48727 8.16667 1.9485V5.52788C6.38777 5.83909 4.75966 6.74049 3.54976 8.09391C2.23069 9.56945 1.50103 11.479 1.5 13.4582V13.9682C2.37445 12.9147 3.46626 12.0628 4.70063 11.4706C5.78891 10.9485 6.96535 10.6393 8.16667 10.5578V14.0495C8.16667 14.5108 8.16667 14.7414 8.26035 14.8563C8.34177 14.9562 8.46483 15.0128 8.59367 15.0096C8.74191 15.006 8.917 14.8559 9.26719 14.5557L16.3261 8.50519Z",
    stroke: "#D0D5DD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledShare);
export default __webpack_public_path__ + "static/media/disabledShare.c7dc7565ef2c58918e577322b2ad1eac.svg";
export { ForwardRef as ReactComponent };